import React from 'react';
import { Box, Typography } from '@mui/material';

const SectionHeader = ({ number, title, subtitle, endAdornment }) => (
  <Box mb={2}>
    <Box display='flex' alignItems='center' justifyContent='space-between' gap={1} mb={0.5}>
      <Box display='flex' alignItems='center' gap={1}>
        <Box
          sx={{
            width: 24,
            height: 24,
            borderRadius: '50%',
            bgcolor: 'primary.main',
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 12,
            fontWeight: 700,
            flexShrink: 0,
          }}
        >
          {number}
        </Box>
        <Typography variant='subtitle1' fontWeight={700} lineHeight={1.3}>
          {title}
        </Typography>
      </Box>
      {endAdornment}
    </Box>
    {subtitle && (
      <Typography variant='caption' color='text.secondary' sx={{ pl: 4, display: 'block' }}>
        {subtitle}
      </Typography>
    )}
  </Box>
);

export default SectionHeader;
